import { Injectable } from '@angular/core';
import { TimezonePickerService } from './timezone-picker.service';
import tzData from './timezones_data';


@Injectable({
  providedIn: 'root'
})
export class TimezoneUtilsService {



  _timeZones;
  map: any = new Map();
  constructor(private zz: TimezonePickerService) {
    this._timeZones = zz.getLocations();
    this.map = new Map();
  }


  getConvertedUntils = value => {
    return value.split('|').map(until => {
      if (until === 'Infinity') {
        return null;
      }
      return parseInt(until, 36) * 1000;
    });
  };

  parseTimezone = (timeZoneConfig) => {
    const offsets = timeZoneConfig.offsets;
    const offsetIndices = timeZoneConfig.offsetIndices;
    const untils = timeZoneConfig.untils;

    const offsetList = offsets.split('|').map(value => parseInt(value));
    const offsetIndexList = offsetIndices.split('').map(value => parseInt(value));
    const dateList = this.getConvertedUntils(untils)
      .map((accumulator => value => accumulator += value)(0));

    return { offsetList, offsetIndexList, dateList };
  };


  tryGet(id) {
    if (!this.map.get(id)) {
      const config = this.getTimezoneById(id);
      if (!config) {
        return false;
      }

      const timeZoneInfo = this.parseTimezone(config);
      this.map.set(id, timeZoneInfo);
    }

    return this.map.get(id);
  }

  wrapper(timestamp: any): any {
    return this.getDisplayedTimeZones(timestamp)
  }

  getDisplayedTimeZones(timestamp) {
    const timeZones = this._timeZones.map((timezone) => {
      const timeZoneInfo = this.parseTimezone(timezone);
      const offset = this.getUtcOffset(timeZoneInfo, timestamp);

      const title = `(GMT ${this.formatOffset(offset)}) ${this.formatId(timezone.id)}`;

      return {
        offset,
        title,
        id: timezone.id
      };
    });
    return timeZones.sort((a,b) => a.offset > b.offset ? 1 : -1);
  }


  formatOffset(offset) {
    const hours = Math.floor(offset);
    const minutesInDecimal = offset - hours;

    const signString = Math.sign(offset) >= 0 ? '+' : '-';
    const hoursString = `0${Math.abs(hours)}`.slice(-2);
    const minutesString = minutesInDecimal > 0 ? `:${minutesInDecimal * 60}` : ':00';

    return signString + hoursString + minutesString;
  }

  formatId (id) {
    return id.split('/').join(' - ').split('_').join(' ');
  }

  getTimezoneById (id) {
    if (!id) {
      return;
    }

    const tzList = this._timeZones;

    for (let i = 0; i < tzList.length; i++) {
      const currentId = tzList[i]['id'];
      if (currentId === id) {
        return tzList[i];
      }
    }

    return;
  }

  getTimeZoneOffsetById (id, timestamp) {
    const timeZoneInfo = this.tryGet(id);

    return timeZoneInfo ? this.getUtcOffset(timeZoneInfo, timestamp) : undefined;
  }

  getTimeZoneDeclarationTuple (id, year) {
    const timeZoneInfo = this.tryGet(id);

    return timeZoneInfo ? this.getTimeZoneDeclarationTupleCore(timeZoneInfo, year) : [];
  }

  getTimeZoneDeclarationTupleCore (timeZoneInfo, year) {
    const offsetList = timeZoneInfo.offsetList;
    const offsetIndexList = timeZoneInfo.offsetIndexList;
    const dateList = timeZoneInfo.dateList;

    const tupleResult = [];

    for (let i = 0; i < dateList.length; i++) {
      const currentDate = dateList[i];
      const currentYear = new Date(currentDate).getFullYear();

      if (currentYear === year) {
        const offset = offsetList[offsetIndexList[i + 1]];
        tupleResult.push({ date: currentDate, offset: -offset / 60 });
      }

      if (currentYear > year) {
        break;
      }
    }

    return tupleResult;
  }

  getUtcOffset (timeZoneInfo, dateTimeStamp) {
    const offsetList = timeZoneInfo.offsetList;
    const offsetIndexList = timeZoneInfo.offsetIndexList;
    const dateList = timeZoneInfo.dateList;

    const infinityUntilCorrection = 1;
    const lastIntervalStartIndex = dateList.length - 1 - infinityUntilCorrection;

    let index = lastIntervalStartIndex;
    while (index >= 0 && dateTimeStamp < dateList[index]) {
      index--;
    }

    const offset = offsetList[offsetIndexList[index + 1]];
    return -offset / 60 || offset;
  }


}